<template>
    <div class="pr-3 lg:pr-5">
        <p class="font-semibold text-primary text-lg lg:text-2xl mb-2 lg:mb-4">Event Waiver and Release of Liability</p>

        <div class="flex flex-col lg:space-y-2 items-start text-xs lg:text-base text-gray-600">
            <p class="leading-normal text-xs lg:text-base">
                <span class="font-semibold">Hosted by:</span> PAFCPIC <br>
                <span class="font-semibold">Organized by:</span> JN Enterpraises Branding Consultancy <br>
                <span class="font-semibold">In Support of:</span> HERO Foundation <br>
                <span class="font-semibold">Event Date:</span> November 15, 2025 <br>
                <span class="font-semibold">Event Venue:</span> Philippine Army Grandstand, Taguig City <br>
                <span class="font-semibold">Event Type:</span> Free Outdoor Event (3KM | 5KM | 10KM Run + Zumba + Booths
                + Games)
            </p>

            <p class="font-bold mt-4">PLEASE READ CAREFULLY BEFORE PROCEEDING</p>
            <p class="text-justify">
                By completing and submitting this form, you agree to the terms and conditions outlined in this
                waiver. Your submission will serve as your legally binding electronic signature under
                applicable electronic signature laws.
            </p>

            <p class="font-bold mt-4">1. DATA PRIVACY</p>
            <p class="leading-normal text-xs lg:text-base text-justify">
                By participating in this Fun Run event, you consent to PAFCPIC's data privacy policy in compliance with
                the Data
                Privacy Act of 2012.
                <br /><br />
                PAFCPIC will be covering the event by capturing photos and videos which may be posted in all of
                PAFCPIC's
                communication channels including its Social Media accounts, Website, Newsletter, Annual Reports, and
                other
                in-house or external publishing partners.
                <br /><br />
                To read more about PAFCPIC's Data Privacy Policy, you may visit this link:
                <a href="https://pafcpic.ph/privacy-policy" target="_blank" rel="noopener noreferrer"
                    class="text-primary hover:underline">
                    https://pafcpic.ph/privacy-policy
                </a>
            </p>


            <p class="font-bold mt-4">2. ASSUMPTION OF RISK</p>
            <p class="leading-normal text-xs lg:text-base text-justify">
                I acknowledge that participation in this event involves inherent risks including, but not limited
                to: <br>
                - Physical exertion from running or Zumba activities <br>
                - Weather exposure and environmental conditions <br>
                - Potential for injury from booths, inflatables, games, or crowded areas <br>
                - Health risks from interaction with others in a public space <br><br>

                I acknowledge that I have consulted, or had the opportunity to consult, a physician regarding
                my physical fitness to participate in this event. I voluntarily assume responsibility for
                participating, with or without such medical clearance, and fully accept all risks inherent or
                incidental to the activity, whether known or unknown. I further agree to bear sole
                responsibility for any injury, illness, damage, or loss that may result from my participation.
            </p>

            <p class="font-bold mt-4">3. RELEASE OF LIABILITY</p>
            <p class="leading-normal text-xs lg:text-base text-justify">
                In consideration of being allowed to participate in PAPSI RUN: FortyFOURWARDofHOPE, I,
                for myself, my heirs, executors, administrators, assigns, and any minor under my care,
                hereby voluntarily, knowingly, and irrevocably release, waive, discharge, and hold harmless
                the following:<br>

                - PAFCPIC (Philippine Army Finance Center Producers Integrated Cooperative) <br>
                - Philippine Army <br>
                - JN Enterpraises Branding Consultancy <br>
                - HERO Foundation <br>
                - All sponsors, vendors, volunteers, staff, and affiliated entities <br><br>
            </p>

            <p class="text-justify">
                from any and all liabilities, claims, actions, causes of action, demands, damages, or
                expenses of whatever kind or nature, whether known or unknown, arising directly or
                indirectly from my participation in the event or from any activities related thereto.
                Any dispute arising from this waiver or participation in the event shall be subject to the
                jurisdiction of the proper courts of Taguig City, to the exclusion of all others.
            </p>

            <p class="font-bold mt-4">4. FITNESS TO PARTICIPATE & MEDICAL CONSENT</p>
            <p class="leading-normal text-xs lg:text-base text-justify">
                I certify that I am physically fit and capable of participating in the event. I authorize event
                personnel to provide emergency medical treatment if necessary and understand that I am
                solely responsible for any resulting medical expenses.
            </p>

            <p class="font-bold mt-4">5. PERSONAL PROPERTY DISCLAIMER</p>
            <p class="leading-normal text-xs lg:text-base text-justify">
                I understand and agree that the event organizers, sponsors, and their representatives shall
                not be responsible or liable for any loss, theft, misplacement or damage, to any personal
                belongings brought to or used during the event, whether occurring before, during or after my
                participation. <br>
                I acknowledge that the organizers do not provide any safekeeping, storage, or security
                services for personal property, and I waive any right to claim compensation or replacement
                for any lost, damaged, or stolen items.
            </p>

            <p class="font-bold mt-4">6. PHOTO & MEDIA RELEASE</p>
            <p class="leading-normal text-xs lg:text-base text-justify">
                I grant permission to the event organizers to use any photographs, video recordings, or
                likenesses of me for promotional and media purposes without compensation.
                PAFCPIC will be covering the event by capturing photos and videos which may be posted in
                all of PAFCPIC&#39;s communication channels including its Social Media accounts, Website,
                Newsletter, Annual Reports, and other in-house or external publishing partners.
            </p>

            <p class="font-bold mt-4">7. MINOR PARTICIPANTS</p>
            <p class="leading-normal text-xs lg:text-base text-justify">
                If I am registering a participant who is below eighteen (18) years of age, I hereby confirm
                that I am the minor’s parent or legal guardian and that I possess the legal authority to
                provide consent on their behalf. <br>
                I further accept full responsibility for the supervision, safety, and conduct of the minor
                throughout the duration of the event, including their arrival at and departure from the venue.
            </p>

            <p class="font-bold mt-4">8. EVENT TERMS</p>
            <p class="leading-normal text-xs lg:text-base text-justify">
                This is a free event with optional timed run categories and wellness activities. <br>
                - Singlets, giveaways, and race kits with timing chips will be distributed while supplies last.<br>
                - The event will feature booths PAFCPIC, food, sponsors, giveaways, inflatable
                attractions, and fun games.<br>
                - Safety protocols will be in place, including an emergency team and security.<br>
                - The organizers reserve the right to postpone or cancel the event due to weather or
                safety concerns, without compensation.<br>
            </p>

            <p class="font-bold mt-4">ELECTRONIC ACKNOWLEDGMENT</p>
            <p class="text-justify">Pursuant to Republic Act No. 8792, otherwise known as the Electronic Commerce Act of
                2000,
                this electronic submission and acknowledgment shall have the same force, effect, and validity
                as a handwritten signature and shall constitute my free and informed consent to be legally
                bound by the provisions contained herein.</p><br>
            <p class="text-justify">By checking the acknowledgment box and submitting this registration form
                electronically, hereby
                confirm that I have carefully read, fully understood, and voluntarily agreed to all the terms and
                conditions set forth in this Event Waiver and Release of Liability.</p><br>

            <!-- Checkbox 1 -->
            <div class="flex flex-row space-x-2 text-xs lg:text-base mt-4 items-center">
                <input type="checkbox" id="agree1" v-model="form.agree1" class="cursor-pointer w-4 h-4"
                    style="accent-color: #016B00;" />
                <label for="agree1" class="cursor-pointer select-none">
                    I have read and understood this waiver and agree to its terms. <span class="text-error">*</span>
                </label>
            </div>

            <!-- Checkbox 2 -->
            <div class="flex flex-row space-x-2 text-xs lg:text-base mt-4 items-center">
                <input type="checkbox" id="agree2" v-model="form.agree2" class="cursor-pointer w-4 h-4"
                    style="accent-color: #016B00;" />
                <label for="agree2" class="cursor-pointer select-none">
                    I am voluntarily participating at my own risk. <span class="text-error">*</span>
                </label>
            </div>

            <!-- Checkbox 3 -->
            <div class="flex flex-row space-x-2 text-xs lg:text-base mt-4 items-center">
                <input type="checkbox" id="agree3" v-model="form.agree3" class="cursor-pointer w-4 h-4"
                    style="accent-color: #016B00;" />
                <label for="agree3" class="cursor-pointer select-none">
                    I understand that this electronic acknowledgment is legally binding. <span
                        class="text-error">*</span>
                </label>
            </div>

            <!-- Checkbox 4 (Visible only if minor) -->
            <div v-if="isMinor" class="flex flex-row space-x-2 text-xs lg:text-base mt-4 items-center">
                <input type="checkbox" id="agree4" v-model="form.agree4" class="cursor-pointer w-4 h-4"
                    style="accent-color: #016B00;" />
                <label for="agree4" class="cursor-pointer select-none">
                    I am the parent/legal guardian of a minor participant and accept these terms on their behalf.
                    <span class="text-error">*</span>
                </label>
            </div>

            <!-- Guardian info (Visible only if minor) -->
            <div v-if="isMinor" class="mt-4 w-full">
                <p class="font-bold mt-4 mb-2">Guardian Information</p>
                <p v-if="filteredGuardianOptions.map(name => ({ value: name, label: name })).length < 1"
                    class="text-error text-xs lg:text-sm text-justify italic pb-3">If the guardian’s name is not listed,
                    ensure the
                    guardian is registered first before proceeding with the minor’s registration.</p>
                <div class="form-grid pb-5 pt-2 w-full">
                    <!-- Guardian Name ComboBox -->
                    <ComboBoxControl v-if="isMinor" label="Guardian Name" fieldId="guardian_name" required
                        :options="filteredGuardianOptions.map(name => ({ value: name, label: name }))"
                        v-model="form.guardian_name" />

                    <TextControl label="Relationship to Minor" fieldId="name" v-model="form.relationship"
                        :required="isMinor" :max-length="64" :placeholder="'e.g FATHER'"/>
                </div>

                <p class="font-bold text-xs lg:text-base">Note:</p>
                <p class="text-xs lg:text-base text-justify">Registering a minor does not automatically register them
                    for the race. Only
                    officially registered
                    runners are eligible to receive a race kit and singlet.</p>
                <p class="text-xs lg:text-base text-justify">- Minors aged 12 to 17 years old may participate in the
                    race and are
                    eligible to receive a
                    race kit and singlet, provided they are accompanied by a parent or legal guardian and
                    actively participate in the race. <br>
                    - Minors below 12 years old may join the race only if accompanied by a parent or legal
                    guardian, but will not be eligible to receive a race kit or singlet.</p>

            </div>

            <!-- Signature and Date -->
            <div class="form-grid pb-5 pt-8 w-full">
                <TextControl label="Digital Signature" fieldId="name" v-model="form.signature"
                    required :max-length="64" :placeholder="'Enter Full Name'"/>
                <TextControl label="Date Signed" fieldId="date" v-model="form.date_signed" :max-length="64" disabled />
            </div>

            <p class="font-bold">
                ✔ SUBMITTING THIS FORM CONSTITUTES YOUR ELECTRONIC SIGNATURE AND
                AGREEMENT TO THE TERMS ABOVE.
            </p>
        </div>

        <!-- Button -->
        <div class="w-full flex justify-end mt-4">
            <div class="w-full lg:w-1/4">
                <ButtonControl ref="proceed" variant="primary" :disabled="!isFormValid" @click="submitWaiver">
                    SUBMIT
                </ButtonControl>
            </div>
        </div>
    </div>
</template>

<script>
import ButtonControl from "../controls/ButtonControl.vue";
import TextControl from "../controls/TextControl.vue";
import ComboBoxControl from "../controls/ComboBoxControl.vue";

export default {
    name: "WaiverContent",
    inject: ["setLoading"],
    components: {
        ButtonControl,
        TextControl,
        ComboBoxControl
    },
    props: {
        name: String,
        isMinor: Boolean,
        age: [Number, String],
        guardianOptions: {
            type: Array,
            default: () => [],
        },
        savedData: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            form: {
                agree1: false,
                agree2: false,
                agree3: false,
                agree4: false,
                guardian_name: "",
                guardianName: '',
                relationship: "",
                signature: "",
                date_signed: "",
            },
        };
    },
    watch: {
        guardianOptions(newVal) {
            console.log("🧭 Waiver.vue guardianOptions received:", newVal);
        }
    },
    computed: {
        // ✅ Filter out the current person's name from the guardian list
        filteredGuardianOptions() {
            if (!this.guardianOptions || !this.name) return [];
            return this.guardianOptions.filter(
                (n) => (n || "").trim().toLowerCase() !== (this.name || "").trim().toLowerCase()
            );
        },

        // ✅ Updated validation logic
        isFormValid() {
            const signatureValid = this.form.signature.trim().length > 0;

            if (this.isMinor) {
                return (
                    this.form.agree1 &&
                    this.form.agree2 &&
                    this.form.agree3 &&
                    this.form.agree4 && // 4th checkbox required
                    this.form.guardian_name &&
                    this.form.guardian_name.trim().length > 0 &&
                    this.form.relationship &&
                    this.form.relationship.trim().length > 0 &&
                    signatureValid
                );
            } else {
                return (
                    this.form.agree1 &&
                    this.form.agree2 &&
                    this.form.agree3 &&
                    signatureValid
                );
            }
        },
    },
    mounted() {
        if (this.savedData) {
            this.form = { ...this.form, ...this.savedData };
        }

        // Get the timestamp from the store
        const timestamp = this.$store?.state?.date?.timestamp;

        if (timestamp) {
            const dateObj = new Date(timestamp.replace(" ", "T")); // convert "YYYY-MM-DD HH:MM:SS" to ISO format
            this.form.date_signed = `${String(dateObj.getMonth() + 1).padStart(2, "0")}/${String(
                dateObj.getDate()
            ).padStart(2, "0")}/${dateObj.getFullYear()}`;
        } else {
            // fallback to today if store date is not available
            const today = new Date();
            this.form.date_signed = `${String(today.getMonth() + 1).padStart(2, "0")}/${String(
                today.getDate()
            ).padStart(2, "0")}/${today.getFullYear()}`;
        }
    },
    methods: {
        submitWaiver() {
            // Always include guardian, relationship, and date, defaulting to null if missing
            const payload = {
                ...this.form,
                guardian_name: this.isMinor ? this.form.guardian_name || null : null,
                relationship: this.isMinor ? this.form.relationship || null : null,
                date: this.form.date || null,
            };

            this.$emit("submitted", payload);
        },
    },
};
</script>

<style scoped>
.form-grid {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 1.25rem;
  /* gap-5 */
}

@media (min-width: 1024px) {
  .form-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.col-span-full-lg {
  grid-column: span 1 / span 1; /* default for small screens */
}

@media (min-width: 1024px) {
  .col-span-full-lg {
    grid-column: span 2 / span 2; /* span 2 columns on lg+ screens */
  }
}
</style>